// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite_cardContainer__dCer\\+ {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.invite_subTitle__na7Qo {
  font: var(--h5);
  font-weight: 600;
  font-family: var(--font-bodoni);
}
@media (max-width: 768px) {
  .invite_subTitle__na7Qo {
    text-align: center;
  }
}

.invite_inviteBtn__t5cyj {
  width: fit-content;
}

.invite_status__j24mb {
  -webkit-text-decoration: solid;
          text-decoration: solid;
  text-transform: capitalize;
}

.invite_removeBtn__AzBp7 {
  width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/components/invitePartner/invite.module.scss"],"names":[],"mappings":"AAqCA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AApCD;;AAuCA;EACC,eAAA;EACA,gBAAA;EACA,+BAAA;AApCD;AAsCC;EALD;IAME,kBAAA;EAnCA;AACF;;AAsCA;EACC,kBAAA;AAnCD;;AAsCA;EACC,8BAAA;UAAA,sBAAA;EACA,0BAAA;AAnCD;;AAsCA;EACC,kBAAA;AAnCD","sourcesContent":["// .form {\r\n// \tdisplay: flex;\r\n// \tflex-direction: column;\r\n// \talign-items: center;\r\n// \tgap: 1rem;\r\n// }\r\n\r\n// .buttonGroup {\r\n// \tdisplay: flex;\r\n// \tflex-direction: column;\r\n// }\r\n\r\n// .confirmation {\r\n// \ttext-align: center;\r\n// \tpadding: 2rem;\r\n// \tbackground-color: #f0f9ff;\r\n// \tborder-radius: 12px;\r\n// \tbox-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\r\n// }\r\n\r\n// .acceptedContainer {\r\n// \ttext-align: center;\r\n// \tpadding: 2rem;\r\n// \tbackground-color: #e6ffed;\r\n// \tborder-radius: 12px;\r\n// \tbox-shadow: 0 0 15px rgba(0, 0, 0, 0.08);\r\n// }\r\n\r\n// .acceptedContainer h2 {\r\n// \tcolor: #2e7d32;\r\n// }\r\n\r\n// .acceptedContainer p {\r\n// \tfont-size: 1.1rem;\r\n// \tmargin-top: 1rem;\r\n// }\r\n\r\n.cardContainer {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 1rem;\r\n}\r\n\r\n.subTitle {\r\n\tfont: var(--h5);\r\n\tfont-weight: 600;\r\n\tfont-family: var(--font-bodoni);\r\n\r\n\t@media (max-width: 768px) {\r\n\t\ttext-align: center;\r\n\t}\r\n}\r\n\r\n.inviteBtn {\r\n\twidth: fit-content;\r\n}\r\n\r\n.status {\r\n\ttext-decoration: solid;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.removeBtn {\r\n\twidth: fit-content;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `invite_cardContainer__dCer+`,
	"subTitle": `invite_subTitle__na7Qo`,
	"inviteBtn": `invite_inviteBtn__t5cyj`,
	"status": `invite_status__j24mb`,
	"removeBtn": `invite_removeBtn__AzBp7`
};
export default ___CSS_LOADER_EXPORT___;
